export default "__VITE_ASSET__BQj8M8mQ__"